export default __webpack_public_path__ + "static/media/16418216967.6bd5e1f1.JPG";